import { Card } from '@ipfabric/ui-components/Card/Card';
import {
  ChangesSelectSnapshots,
  useChangesSelectSnapshot,
} from 'pages/Management/Changes/ChangesSelectSnapshots';
import { ChangesSummary } from 'pages/Management/Changes/ChangesSummary';
import type { FC } from 'react';
import { useSearchParams } from 'react-router-dom';

export const ChangesPage: FC = () => {
  const selectSnapshotModel = useChangesSelectSnapshot();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <div className='flex flex-col flex-1 gap m'>
      <Card className='p'>
        <div className='text-level-5 font-semibold'>Snapshot Selection</div>
        <ChangesSelectSnapshots
          model={selectSnapshotModel}
          className='mt'
          onSubmit={() => {
            if (
              selectSnapshotModel.before !== null &&
              selectSnapshotModel.after !== null
            ) {
              setSearchParams({
                before: selectSnapshotModel.before,
                after: selectSnapshotModel.after,
              });
            }
          }}
        />
      </Card>
      {searchParams.has('before') && searchParams.has('after') && (
        <ChangesSummary />
      )}
    </div>
  );
};
